export const PROFILE_TAB_KEY = 'profile';
export const PAYMENTS_TAB_KEY = 'payments';
export const SETTINGS_TAB_KEY = 'settings';
export const USER_MANAGEMENT_TAB_KEY = 'user';
export const REPORT_DASHBOARD_PAGE = 'dashboard';
